<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" :picker-options="pickerOptions"  unlink-panels
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>
		<transition name="el-zoom-in-center">
			<div>
				<auto-data-table   :formHeight="formHeight" :dataList="dataList" :facList="facList" dataType="uploadhour" :showRecording="false"
				 :listLoading="listLoading" :funName="funName"  :carFlag="carFlag"></auto-data-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar"  >
					<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" 
					:page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
					</el-pagination>
				</el-col>
			</div>
		</transition>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,selectHandView ,getFunctionalAreaList} from '../../api/api';
	import {formatDate,in_array,factorExcept,hourFactorExcept} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
	import AutoDataTable from '../../components/MyTable/AutoDataTable.vue'

	export default {
		props: {
            collapsed: {
                type: Boolean,
            },
        },
		components: { myButton ,AutoDataTable},
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
					mn:"",
					time:[]
				},
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				dataList:[],
				firstFlag:true,
				devices:[],
				facList:[],
				projects:[],
				formHeight:0,
				dataType:'hour',

				type:sessionStorage.getItem("type"),
				functionalAreaMap:new Map(),
				deviceMap:new Map(),
				funName:"",
				dataObj:{},
				fac:"",
				carFlag:0
			}
			
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getDataList(1);
				}else if(type=="export"){
					this.exportToExcel();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDataList(0);
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDataList(1);
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					var flag=false;
					if(this.filters.deviceId!=""){
						this.devices.forEach(item => {
							if(item.mnCode==this.filters.mn){
								flag=true;
							}
							this.deviceMap.set(item.mnCode,item.functionalAreaId)
						});		
					}
					if(!flag&&this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList(1);
					}
				});
            },
			//获取历史数据信息
			getDataList(type){
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
					//如果开始时间超过三个月
					var d1 = new Date(this.filters.time[0]);
					var d2 = new Date(this.filters.time[1]);
					var days=parseInt(d2 - d1) / 1000 / 3600 / 24 ;
					if(days>188){
						this.$message({
							message: "选择时间范围超过"+day+"天",
							type: 'warn'
						})
						return;
					}
                }
				if(type==1){//换条件后重新查询，页数改为第一条
					this.page=1;
				}

				let para = {
					dataType:this.dataType,
					page: this.page,
					pageSize:this.pageSize,
                    mn: this.filters.mn,
					startDate: starttime,
                    endDate: endtime
				};
				if(this.filters.mn==""){
					this.$message({
						message: "未选择设备",
						type: 'warning'
					})
					return;
				}
				this.listLoading = true;
				selectHandView(para).then((res) => {
					this.listLoading = false;
					if(res.data.result=="false"||res.data.result==false){
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
                    }

					this.chooseDataType=this.dataType;
					var funid=this.deviceMap.get(this.filters.mn);
					this.funName=this.functionalAreaMap.get(funid).name;
					this.total = res.data.total;
					this.dataList = res.data.data;
					var nullFactor=hourFactorExcept();
					if(this.dataList.length>0){
						this.facList=[];
						var arr=factorExcept();
						for (var element in this.dataList[0]) {
							if(in_array(element,arr)){
								continue
							}
							if(in_array(element,nullFactor)){
								continue;
							}
							var obj=JSON.parse(sessionStorage.getItem(element));
							if(obj.unit.trim()!=""){
								obj.title=obj.remark+'('+obj.unit+')';
							}else{
								obj.title=obj.remark;
								obj.unit="/";
							}
							this.facList.push(obj);
						}
					}else{
						this.$message({
							message: "查询条件下无数据",
							type: 'warning'
						})
						return;
					}
				}).catch(() => {
					this.listLoading = false;
				});
			},
		
			//历史数据导出信息
			exportToExcel(){
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
					
					//如果开始时间超过三个月
					var d1 = new Date(this.filters.time[0]);
					var d2 = new Date(this.filters.time[1]);
					var days=parseInt(d2 - d1) / 1000 / 3600 / 24 ;
					if(days>366){
						this.$message({
							message: "选择时间范围超过"+day+"天",
							type: 'warn'
						})
						return;
					}
                }
				let para = {
					dataType:this.dataType,
					page: 1,
					pageSize:999999,
                    mn: this.filters.mn,
					startDate: starttime,
                    endDate: endtime
				};
				if(this.filters.mn==""){
					this.$message({
						message: "未选择设备",
						type: 'warning'
					})
					return;
				}
				this.listLoading = true;
				selectHandView(para).then((res) => {
					this.listLoading = false;
					var dataList = res.data.data;
					var nullFactor=hourFactorExcept();
					if(dataList.length>0){

						var tHeader =  ['时间' ];
						var filterVal = [ 'time'];  
						var facList=[];
						var arr=factorExcept();

						for (var element in dataList[0]) {
							if(in_array(element,arr)){
								continue
							}
							if(in_array(element,nullFactor)){
								continue;
							}
							var obj=JSON.parse(sessionStorage.getItem(element));
							if(obj.unit.trim()!=""){
								obj.title=obj.remark+'('+obj.unit+')';
							}else{
								obj.title=obj.remark;
							}
							facList.push(obj);

								tHeader.push(obj.title);
								filterVal.push(element);
							}

							require.ensure([], () => {
								const { export_json_to_excel } = require('vendor/Export2Excel');

								var data=[];
								var sheetName=[];
								data.push(this.formatJson(filterVal, dataList));
								sheetName.push('Sheet1');

								export_json_to_excel(tHeader, data, '手工数据记录表',sheetName);
							}) 
					}else{
						this.$message({
							message: "查询条件下无数据",
							type: 'warning'
						})
						return;
					}
				}).catch(function(err) {
					this.listLoading = false;
				});
			},
			formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var end = new Date();
				var start = new Date();
				start.setTime(start.setDate(start.getDate()-1));
				this.filters.time= [formatDate(start), formatDate(end)];
			},
			getFunctionalAreaList(){
				getFunctionalAreaList({}).then((res) => {
					
					res.data.data.forEach(element => {
						this.functionalAreaMap.set(element.id,element);
					});
					this.getProjects();
				});
			},
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)

			this.getFunctionalAreaList();
			this.setTime();
		}
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }

	.dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
	.tabSelect{
		color: #fff;
		background: #409eff;
	}
</style>


// WEBPACK FOOTER //
// DataQuery.vue?2bd494ee